import dayjs from "dayjs";
import parse, { attributesToProps, domToReact } from 'html-react-parser';
// import ReactStars from "react-stars";
import Image from "next/image";
import dynamic from "next/dynamic";

const ReactStars = dynamic(() => import("react-stars"), {
  ssr: false,
});
import { cardColors, textColors } from "src/constants/wall.constant";
import {
  socialCardKeys,
  SOCIAL_CARD_TYPE,
} from "src/constants/socialcard.constant";
import ClassNames from "src/components/componentHelper/ClassNames";
import TiktokIcon from "src/components/common/TiktokIcon";
import SkoolIcon from "src/components/common/SkoolIcon";

import ReadMoreReadLess from 'src/components/componentHelper/ReadMoreReadLess'

const MiscellaneousCard = ({
  cardItem,
  cardWidth,
  miscType,
  darkModeEnabled = false,
  cardFontColor,
  darkCardTheme,
  cardBackgroundObject,
  linkColor,
  highlightColor,
  smallSize,
  refresh,
  isDateTimeDisabled, ratingColor,
  shortenText,
  fontStyle
}) => {
  const options = {
    replace: domNode => {
       const attribProps = attributesToProps(domNode.attribs);

       if (domNode.name === 'a') {
          return <a {...attribProps} style={linkColor && linkColor!=='#0b57a8'?{color: linkColor} :darkModeEnabled ? { color: '#6fb0f6' } : { color: '#0b57a8' }}>{domToReact(domNode.children, options)}</a>
       }
       else if(domNode.name === 'b'){
        let bStyle = highlightColor ? { backgroundColor: highlightColor } : { backgroundColor: '#fcf807' };
        if (darkModeEnabled) {
          bStyle.color = '#726c6c';
        }
        return <b style={bStyle}>{domToReact(domNode.children, options)}</b>
     }
    }
 }

  const renderIcon = (messageLink) => {
    if (miscType === SOCIAL_CARD_TYPE.CAPTERRA)
      return (
        <div style={{ minWidth: "28px" }}>
          <a
            className="cursor-pointer"
            href={messageLink || void 0}
            target={messageLink ? "_blank" : "_self"}
            rel="noreferrer noopener"
          >
            <svg
              width={28}
              height={28}
              viewBox="0 0 321 327"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.904785 120.38L136.086 120.407L218.285 120.421V38.9868L0.904785 120.38Z"
                fill="#FF9D28"
              />
              <path
                d="M218.285 38.9872V326.49L320.95 0.53418L218.285 38.9872Z"
                fill="#68C5ED"
              />
              <path
                d="M218.285 120.421L136.086 120.407L218.285 326.49V120.421Z"
                fill="#044D80"
              />
              <path
                d="M0.904785 120.38L157.165 173.285L136.086 120.407L0.904785 120.38Z"
                fill="#E54747"
              />
            </svg>
          </a>
        </div>
      );
      else if(miscType===SOCIAL_CARD_TYPE.AIRBNB){
        return(
          <div className="" style={{ minWidth: "25px" }}>
      <a
                                        className="cursor-pointer"
                                        href={messageLink || void 0}
                                        target={
                                            messageLink ? "_blank" : "_self"
                                        }
                                        rel="noreferrer"
                                    >
                                                  <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="5 4 38 40"
      width="25px"
      height="25px"
    >
      <path
        fill="#ff5252"
        d="M42.459,32.519c-1.037-3.336-9.539-19.596-12.12-24.5l-0.026-0.048C29.153,5.559,26.676,4,24,4 s-5.153,1.559-6.291,3.929L17.661,8.02C15.08,12.923,6.578,29.183,5.542,32.518C5.261,33.421,5,34.407,5,35.5 c0,4.687,3.813,8.5,8.5,8.5c4.654,0,7.612-1.949,10.5-5.184C26.888,42.051,29.846,44,34.5,44c4.687,0,8.5-3.813,8.5-8.5 C43,34.407,42.739,33.421,42.459,32.519z M23.999,34.662C22.33,32.515,20,28.881,20,26c0-2.206,1.794-4,4-4s4,1.794,4,4 C28,28.872,25.668,32.511,23.999,34.662z M34.5,41c-3.287,0-5.521-1.107-8.325-4.258C27.878,34.596,31,30.104,31,26 c0-3.86-3.141-7-7-7s-7,3.14-7,7c0,4.104,3.122,8.596,4.825,10.742C19.021,39.893,16.787,41,13.5,41C10.468,41,8,38.533,8,35.5 c0-0.653,0.162-1.308,0.406-2.09C9.17,30.95,15.3,18.948,20.316,9.417l0.076-0.146C21.055,7.891,22.471,7,24,7 s2.945,0.891,3.615,2.285l0.068,0.132C32.7,18.948,38.83,30.95,39.595,33.411C39.838,34.192,40,34.847,40,35.5 C40,38.533,37.532,41,34.5,41z"
      />
    </svg>
                                </a>
        </div>
        )
      }
      else if(miscType===SOCIAL_CARD_TYPE.TRIPADVISOR){
        return(
          <div className="" style={{ minWidth: "25px" }}>
      <a
                                        className="cursor-pointer"
                                        href={messageLink || void 0}
                                        target={
                                            messageLink ? "_blank" : "_self"
                                        }
                                        rel="noreferrer"
                                    >
                 <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25px"
        height="25px"
        fillRule="evenodd"
        clipRule="evenodd"
        imageRendering="optimizeQuality"
        shapeRendering="geometricPrecision"
        textRendering="geometricPrecision"
        viewBox="12.5 3.674 332.368 332.812"
      >
        <path
          fill="#46dba4"
          d="M221.5 9.5a363 363 0 0 1-32-4 921 921 0 0 1-35 1.5 68.9 68.9 0 0 1-21 3.5q5.558-2.646 12-3.5 38.386-7.728 76 2.5"
        ></path>
        <path
          fill="#2de2a0"
          d="M221.5 9.5q93.072 27.324 119.5 121 21.28 115.237-74.5 181.5a111 111 0 0 1-22 10.5 15.4 15.4 0 0 1-7-1 27 27 0 0 1-10 2 6.85 6.85 0 0 1-1 4 46 46 0 0 0-13.5 4q-1.24-2.858-3.5-1a4.46 4.46 0 0 0 2 1.5 73.6 73.6 0 0 1-11 2 536 536 0 0 1-52-.5q-73.01-14.121-112.5-77a162.2 162.2 0 0 1-15.5-36 264 264 0 0 0-5-27 577 577 0 0 1-1-48Q27.26 69.694 91.5 28a165.5 165.5 0 0 1 42-17.5 68.9 68.9 0 0 0 21-3.5 921 921 0 0 0 35-1.5 363 363 0 0 0 32 4"
        ></path>
        <path
          fill="#010401"
          d="M257.5 115.5a792 792 0 0 0 40 1.5q1.129 1.006 1 2.5a209 209 0 0 0-16 18q15.892 15.785 19 38a98 98 0 0 1-2 25 104.3 104.3 0 0 1-13 24q-30.32 29.272-70 15a75.8 75.8 0 0 1-18-11 578 578 0 0 0-19.5 21 583 583 0 0 0-19.5-21 125.6 125.6 0 0 1-18 11 6167 6167 0 0 1-13 4q-58.296 4.685-72-52a113 113 0 0 1 1-20q3.488-19.976 18-34a256 256 0 0 0-18-20l43-2q78.477-47.851 157 0"
        ></path>
        <path
          fill="#238b62"
          d="M190.5 112.5a460 460 0 0 0-31 1q9.152-2.208 19-2 6.272.001 12 1"
        ></path>
        <path
          fill="#003a22"
          d="m100.5 115.5-43 2q-.814-.09-1-1a485 485 0 0 1 44-1"
        ></path>
        <path
          fill="#013922"
          d="M257.5 115.5a485 485 0 0 1 44 1q-1.032 2.032-3 3 .129-1.494-1-2.5a792 792 0 0 1-40-1.5"
        ></path>
        <path
          fill="#2fe1a0"
          d="M190.5 112.5q17.768 1.132 34 8.5-37.499 14.994-45.5 54.5-8.072-40.081-46.5-54.5a95.9 95.9 0 0 1 27-7.5 460 460 0 0 1 31-1"
        ></path>
        <path
          fill="#30e0a0"
          d="M231.5 141.5q24.754-3.024 41.5 15 13.506 19.836 6 43-18.088 32.907-54.5 22.5-28.525-14.562-25.5-46.5 6.414-26.659 32.5-34"
        ></path>
        <path
          fill="#020703"
          d="M233.5 161.5q20.81-3.34 28.5 16 1.499 29-27.5 26.5-20.401-8.172-14.5-29.5 4.614-8.867 13.5-13"
        ></path>
        <path
          fill="#339973"
          d="M57.5 171.5a113 113 0 0 0-1 20q-.997-4.723-1-10 .02-5.608 2-10"
        ></path>
        <path fill="#30a378" d="M156.5 169.5q6 13.5 0 27 2-13.5 0-27"></path>
        <path
          fill="#4adba6"
          d="M14.5 145.5q-.5 24.021 1 48 3.185 13.275 5 27-5.919-16.327-7.5-34-1-16.5 0-33 .274-4.297 1.5-8"
        ></path>
        <path
          fill="#32b988"
          d="M301.5 175.5q1.979 10.765 0 22a44 44 0 0 1-2 3 98 98 0 0 0 2-25"
        ></path>
        <path
          fill="#30e0a0"
          d="M156.5 169.5q2 13.5 0 27-7.808 23.045-32 27.5-44.282 2.226-49-42 6.072-42.572 49-40 14.835 3.543 25.5 14.5 4.848 5.697 6.5 13"
        ></path>
        <path fill="#2e956f" d="M134.5 196.5q-1 4-5 5 2-3 5-5"></path>
        <path
          fill="#020502"
          d="M134.5 196.5q-3 2-5 5-28.503 10.754-34-19 3.597-24.337 28-20.5 24.391 11.48 11 34.5"
        ></path>
        <path
          fill="#37d99e"
          d="M286.5 224.5q.472 2.59.5 5-5.757 3.55-11.5 7-1.817 1.16 0 2.5-4.171.21-6.5 3.5a4.46 4.46 0 0 0-1.5-2 19.95 19.95 0 0 1-8 2.5q2.909 1.362 3 4.5a22.3 22.3 0 0 1-8-2 383 383 0 0 1-30 1.5q-2.41-4.957-8-4.5v-3q39.68 14.272 70-15"
        ></path>
        <path
          fill="#2da076"
          d="M141.5 239.5q-5.581 4.356-13 4a6167 6167 0 0 0 13-4"
        ></path>
        <path
          fill="#3ed8a0"
          d="M244.5 322.5q-24.058 11.423-51 13.5-22.89 1.69-45-2.5a536 536 0 0 0 52 .5 73.6 73.6 0 0 0 11-2 4.46 4.46 0 0 1-2-1.5q2.26-1.858 3.5 1a46 46 0 0 1 13.5-4 6.85 6.85 0 0 0 1-4 27 27 0 0 0 10-2 15.4 15.4 0 0 0 7 1"
        ></path>
      </svg>
                                </a>
        </div>
        )
      }
      else if(miscType===SOCIAL_CARD_TYPE.BOOKING){
        return(
          <div className="" style={{ minWidth: "25px" }}>
      <a
                                        className="cursor-pointer"
                                        href={messageLink || void 0}
                                        target={
                                            messageLink ? "_blank" : "_self"
                                        }
                                        rel="noreferrer"
                                    >
               <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25px"
        height="25px"
        fillRule="evenodd"
        clipRule="evenodd"
        imageRendering="optimizeQuality"
        shapeRendering="geometricPrecision"
        textRendering="geometricPrecision"
        viewBox="31.5 29.988 295 297.512"
      >
        <path
          fill="#19437d"
          d="M279.5 326.5q-1.008-1.15-2.5-2-118.645 1.248-237.5 1.5 119.5.75 239 .5a7598 7598 0 0 1-246.5 0q-1-123.5 0-247Q36.814 40.06 75.5 32a611 611 0 0 0 34.5-1.5 3276 3276 0 0 0 150 0q30.476-3.507 53 17 10.102 11.706 13 27 1 104.5 0 209-8.558 38.338-46.5 43"
        ></path>
        <path
          fill="#fbfcfd"
          d="M123.5 106.5q22.506-.25 45 .5 37.016 4.503 36.5 41.5-1.993 15.735-14.5 25.5 30.797 20.417 15.5 54.5-11.313 16.799-31.5 20.5-31.496.75-63 .5-.25-65.502.5-131 3.028-8.775 11.5-12"
        ></path>
        <path
          fill="#1b427b"
          d="M163.5 164.5q-11.222-1.488-23-1 .49-13.274-1-26 .51-4.762 5-6.5a121 121 0 0 1 22 0q14.987 7.438 9.5 23.5-3.4 8.657-12.5 10"
        ></path>
        <path
          fill="#061a44"
          d="M139.5 137.5q1.49 12.726 1 26 11.778-.488 23 1h-24z"
        ></path>
        <path
          fill="#1a437d"
          d="M178.5 193.5q-1.251 2.645 1.5 5a43.4 43.4 0 0 1-1 17q-2.5-1.26-.5 1.5l-8 1q1.972 2.093-1 3l2 1q-2.826.324-5 2-12.99.75-26 .5.492-15.77-1-31 1.072-3.382 4-5.5 13.958-2.847 28 0 4.149 2.056 7 5.5"
        ></path>
        <path
          fill="#143062"
          d="M139.5 193.5q1.492 15.23 1 31 13.01.25 26-.5 2.174-1.676 5-2l-2-1q2.972-.907 1-3l8-1q-2-2.76.5-1.5a43.4 43.4 0 0 0 1-17q-2.751-2.355-1.5-5 6.283 9.767 2.5 21-3.348 7.846-11.5 10.5-14.991.75-30 .5z"
        ></path>
        <path
          fill="#1a9dd9"
          d="M236.5 217.5q19.577-2.422 23 17-4.014 21.504-25 15.5-17.266-12.366-4-29 2.898-2.188 6-3.5"
        ></path>
        <path
          fill="#093273"
          d="M279.5 326.5h-1q-119.5.25-239-.5 118.855-.252 237.5-1.5 1.492.85 2.5 2"
        ></path>
      </svg>
                                </a>
        </div>
        )
      }
    else if (miscType === SOCIAL_CARD_TYPE.FACEBOOK)
      return (
        <div style={{ minWidth: "30px" }}>
          <a
            className="cursor-pointer"
            href={messageLink || void 0}
            target={messageLink ? "_blank" : "_self"}
            rel="noreferrer noopener"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              data-name="Ebene 1"
              width="30px"
              height="30px"
              viewBox="0 0 1024 1024"
            >
              <path
                fill="#1877f2"
                d="M1024,512C1024,229.23016,794.76978,0,512,0S0,229.23016,0,512c0,255.554,187.231,467.37012,432,505.77777V660H302V512H432V399.2C432,270.87982,508.43854,200,625.38922,200,681.40765,200,740,210,740,210V336H675.43713C611.83508,336,592,375.46667,592,415.95728V512H734L711.3,660H592v357.77777C836.769,979.37012,1024,767.554,1024,512Z"
              />
              <path
                fill="#fff"
                d="M711.3,660,734,512H592V415.95728C592,375.46667,611.83508,336,675.43713,336H740V210s-58.59235-10-114.61078-10C508.43854,200,432,270.87982,432,399.2V512H302V660H432v357.77777a517.39619,517.39619,0,0,0,160,0V660Z"
              />
            </svg>
          </a>
        </div>
      );
    else if (miscType === SOCIAL_CARD_TYPE.G2)
      return (
        <div style={{ minWidth: "32px" }}>
          <a
            className="cursor-pointer"
            href={messageLink || void 0}
            target={messageLink ? "_blank" : "_self"}
            rel="noreferrer noopener"
          >
            <Image
              className="flex-shrink-0 "
              src="/G2Logo.svg"
              alt="G2"
              width={22}
              height={22}
            />
          </a>
        </div>
      );
    else if (miscType === SOCIAL_CARD_TYPE.SHOPIFY)
      return (
        <div style={{ minWidth: "28px" }}>
          <a
            className="cursor-pointer"
            href={messageLink || void 0}
            target={messageLink ? "_blank" : "_self"}
            rel="noreferrer noopener"
          >
            <svg
              width={28}
              height={28}
              viewBox="0 0 256 292"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="xMidYMid"
            >
              <path
                d="M223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-1.703-1.703-5.029-1.185-6.32-.805-.19.056-3.388 1.043-8.678 2.68-5.18-14.906-14.322-28.604-30.405-28.604-.444 0-.901.018-1.358.044C129.31 3.407 123.644.779 118.75.779c-37.465 0-55.364 46.835-60.976 70.635-14.558 4.511-24.9 7.718-26.221 8.133-8.126 2.549-8.383 2.805-9.45 10.462C21.3 95.806.038 260.235.038 260.235l165.678 31.042 89.77-19.42S223.973 58.8 223.775 57.34zM156.49 40.848l-14.019 4.339c.005-.988.01-1.96.01-3.023 0-9.264-1.286-16.723-3.349-22.636 8.287 1.04 13.806 10.469 17.358 21.32zm-27.638-19.483c2.304 5.773 3.802 14.058 3.802 25.238 0 .572-.005 1.095-.01 1.624-9.117 2.824-19.024 5.89-28.953 8.966 5.575-21.516 16.025-31.908 25.161-35.828zm-11.131-10.537c1.617 0 3.246.549 4.805 1.622-12.007 5.65-24.877 19.88-30.312 48.297l-22.886 7.088C75.694 46.16 90.81 10.828 117.72 10.828z"
                fill="#95BF46"
              />
              <path
                d="M221.237 54.983c-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-.637-.634-1.496-.959-2.394-1.099l-12.527 256.233 89.762-19.418S223.972 58.8 223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357"
                fill="#5E8E3E"
              />
              <path
                d="M135.242 104.585l-11.069 32.926s-9.698-5.176-21.586-5.176c-17.428 0-18.305 10.937-18.305 13.693 0 15.038 39.2 20.8 39.2 56.024 0 27.713-17.577 45.558-41.277 45.558-28.44 0-42.984-17.7-42.984-17.7l7.615-25.16s14.95 12.835 27.565 12.835c8.243 0 11.596-6.49 11.596-11.232 0-19.616-32.16-20.491-32.16-52.724 0-27.129 19.472-53.382 58.778-53.382 15.145 0 22.627 4.338 22.627 4.338"
                fill="#FFF"
              />
            </svg>
          </a>
        </div>
      );
    else if (miscType === SOCIAL_CARD_TYPE.SLACK)
      return (
        <div style={{ minWidth: "23px" }}>
          <a
            className="cursor-pointer"
            href={messageLink || void 0}
            target={messageLink ? "_blank" : "_self"}
            rel="noreferrer noopener"
          >
            <svg
              width={23}
              height={23}
              xmlns="http://www.w3.org/2000/svg"
              enableBackground="new 0 0 2447.6 2452.5"
              viewBox="0 0 2447.6 2452.5"
            >
              <g clipRule="evenodd" fillRule="evenodd">
                <path
                  d="m897.4 0c-135.3.1-244.8 109.9-244.7 245.2-.1 135.3 109.5 245.1 244.8 245.2h244.8v-245.1c.1-135.3-109.5-245.1-244.9-245.3.1 0 .1 0 0 0m0 654h-652.6c-135.3.1-244.9 109.9-244.8 245.2-.2 135.3 109.4 245.1 244.7 245.3h652.7c135.3-.1 244.9-109.9 244.8-245.2.1-135.4-109.5-245.2-244.8-245.3z"
                  fill="#36c5f0"
                />
                <path
                  d="m2447.6 899.2c.1-135.3-109.5-245.1-244.8-245.2-135.3.1-244.9 109.9-244.8 245.2v245.3h244.8c135.3-.1 244.9-109.9 244.8-245.3zm-652.7 0v-654c.1-135.2-109.4-245-244.7-245.2-135.3.1-244.9 109.9-244.8 245.2v654c-.2 135.3 109.4 245.1 244.7 245.3 135.3-.1 244.9-109.9 244.8-245.3z"
                  fill="#2eb67d"
                />
                <path
                  d="m1550.1 2452.5c135.3-.1 244.9-109.9 244.8-245.2.1-135.3-109.5-245.1-244.8-245.2h-244.8v245.2c-.1 135.2 109.5 245 244.8 245.2zm0-654.1h652.7c135.3-.1 244.9-109.9 244.8-245.2.2-135.3-109.4-245.1-244.7-245.3h-652.7c-135.3.1-244.9 109.9-244.8 245.2-.1 135.4 109.4 245.2 244.7 245.3z"
                  fill="#ecb22e"
                />
                <path
                  d="m0 1553.2c-.1 135.3 109.5 245.1 244.8 245.2 135.3-.1 244.9-109.9 244.8-245.2v-245.2h-244.8c-135.3.1-244.9 109.9-244.8 245.2zm652.7 0v654c-.2 135.3 109.4 245.1 244.7 245.3 135.3-.1 244.9-109.9 244.8-245.2v-653.9c.2-135.3-109.4-245.1-244.7-245.3-135.4 0-244.9 109.8-244.8 245.1 0 0 0 .1 0 0"
                  fill="#e01e5a"
                />
              </g>
            </svg>
          </a>
        </div>
      );
    else if (miscType === SOCIAL_CARD_TYPE.AMAZON)
      return (
        <div style={{ minWidth: "24px" }}>
          <a
            className="cursor-pointer"
            href={messageLink || void 0}
            target={messageLink ? "_blank" : "_self"}
            rel="noreferrer noopener"
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="#F90"
                fillRule="evenodd"
                d="M11.9924596,23.9397465 C8.83711397,23.9185077 6.03567124,22.8789612 3.53203329,20.9850151 C2.63838806,20.3088366 1.82646601,19.5437784 1.08564773,18.7032301 C1.0593301,18.6732188 1.01408224,18.6445926 1.01108111,18.6122727 C0.999538287,18.4963828 1.00253942,18.3793386 1,18.2627561 C1.10019169,18.278916 1.21815932,18.2662189 1.29780479,18.3156222 C1.96751928,18.7327798 2.61183957,19.1935692 3.29817573,19.5802537 C5.2872347,20.7005999 7.41480753,21.4266434 9.67581537,21.7720046 C10.8557226,21.9520726 12.0409395,22.0114027 13.2256946,21.9426075 C15.4894728,21.8114811 17.6530592,21.2481914 19.7120677,20.2936001 C20.0373444,20.1428508 20.3561571,19.9780193 20.6756624,19.8152656 C20.8303362,19.7363127 20.9829323,19.7039928 21.1142896,19.8425066 C21.2530343,19.9886387 21.247032,20.165013 21.1503032,20.3279977 C21.0948977,20.4217254 21.0106351,20.5020634 20.9279885,20.5757066 C19.0869085,22.2092467 16.9334797,23.2123179 14.5316495,23.6788787 C13.7001046,23.8404782 12.8480135,23.8958838 12.0051567,24 C12.0010013,23.9799155 11.996615,23.959831 11.9924596,23.9397465 M20.882048,18.8454608 C20.4263375,18.8890927 19.9207619,18.9387268 19.4149554,18.9848981 C19.3041444,18.9950558 19.1914864,19.0015197 19.0806753,18.9948249 C18.9532426,18.9872066 18.9329272,18.9087155 19.0026459,18.8159112 C19.0442,18.7605056 19.1065313,18.718028 19.1653996,18.6783207 C19.7005248,18.3191081 20.3062921,18.1618949 20.9339907,18.0787866 C21.5298312,17.9998337 22.124979,18.0183022 22.7074298,18.1743612 C23.1005783,18.2796317 23.186226,18.3269573 23.1569073,18.7845147 C23.0793395,19.9902778 22.691039,21.086615 21.8167857,21.9673322 C21.7719996,22.0125801 21.7297528,22.0707559 21.6743473,22.0926873 C21.6004732,22.1217752 21.5148255,22.1213135 21.4342566,22.1335489 C21.4361035,22.0601365 21.4208669,21.9809528 21.4427983,21.9142353 C21.6512617,21.2800727 21.8689593,20.6489112 22.0762683,20.0145177 C22.1178225,19.8873158 22.1335207,19.750418 22.1494498,19.6165213 C22.2002382,19.1887443 22.0291736,18.9735861 21.575079,18.9070995 C21.3631528,18.8761647 21.1479946,18.8683156 20.882048,18.8454608 M13.9965473,9.42010077 C13.1377614,9.41525279 12.3166051,9.45242067 11.5310007,9.71582785 C11.142931,9.84603088 10.7495517,10.0110932 10.4155024,10.2426422 C9.49276931,10.8818837 9.25267863,11.8334739 9.32863039,12.8935666 C9.36879941,13.4550094 9.53755546,13.9746672 9.95171189,14.381898 C10.5401649,14.9604242 11.5307698,15.0363759 12.3260702,14.5663522 C13.0193321,14.1565821 13.4325651,13.5242663 13.7008203,12.7873726 C14.0960465,11.7021166 13.9716148,10.5713818 13.9965473,9.42010077 M14.6290939,15.7725771 C14.3204389,16.0535293 14.0353312,16.3183217 13.744683,16.5768809 C12.627107,17.5707178 11.3066083,18.0146547 9.82427914,18.0444352 C9.01951364,18.0605951 8.22929209,17.9998799 7.47600757,17.7023059 C6.13427002,17.1720287 5.2787161,16.1915815 4.93173889,14.8002098 C4.5009608,13.0722494 4.64640035,11.4084672 5.66886346,9.89797358 C6.4246874,8.7815519 7.51779258,8.11783967 8.77988467,7.71153236 C9.86283216,7.36293915 10.983871,7.2101122 12.1092961,7.08406459 C12.726837,7.01480766 13.3450705,6.953169 13.9928536,6.88506635 C13.9734617,6.11169732 14.0833494,5.33578887 13.8116313,4.5880449 C13.5708481,3.92571782 13.0622714,3.58520459 12.3976357,3.43283935 C11.3913326,3.20221378 10.250671,3.57758633 9.70977435,4.37103986 C9.52624349,4.64044931 9.41404727,4.9684963 9.31547158,5.28407703 C9.17649601,5.72870651 8.97195721,5.87345349 8.51024436,5.81850966 C7.60782659,5.71162313 6.70333111,5.62297427 5.80091334,5.51747288 C5.35328272,5.46483761 5.17575413,5.20997212 5.26301786,4.77503861 C5.65986006,2.79567561 6.80629307,1.4123839 8.67207471,0.684262729 C10.8742142,-0.174984891 13.1252952,-0.241702398 15.3569843,0.578992199 C17.2063751,1.25909523 18.2221434,2.61445331 18.3574252,4.59243118 C18.402904,5.26006796 18.4093679,5.9311676 18.4121382,6.60088209 C18.4192948,8.33299786 18.4276056,10.0651136 18.4093679,11.7969985 C18.3992103,12.7615167 18.6667729,13.6175323 19.2531482,14.3791277 C19.3939706,14.5624277 19.5366399,14.7461894 19.6559926,14.9433408 C19.8538366,15.2702335 19.8009705,15.5181733 19.5149394,15.7649588 C18.7780456,16.4007374 18.0425371,17.0383629 17.3074902,17.67645 C16.9027989,18.0275826 16.6223083,18.0227347 16.2153085,17.6799129 C15.679029,17.2281268 15.2385549,16.6964645 14.8583344,16.1110126 C14.7890775,16.0043569 14.715896,15.9002407 14.6290939,15.7725771"
              />
            </svg>
          </a>
        </div>
      );
      else if (miscType === SOCIAL_CARD_TYPE.DISCORD){
        return (
          <div style={{ minWidth: "25px" }}>
          <svg width={25} height={25} xmlns="http://www.w3.org/2000/svg" className="mr-2 flex-shrink-0" viewBox="0 0 127.14 96.36">
          <defs>
            <style dangerouslySetInnerHTML={{ __html: ".cls-1{fill:#5865f2;}" }} />
          </defs>
          <g id="discord2">
            <g id="Discord_Logos" data-name="Discord Logos">
              <g
                id="Discord_Logo_-_Large_-_White"
                data-name="Discord Logo - Large - White"
              >
                <path
                  className="cls-1"
                  d="M107.7,8.07A105.15,105.15,0,0,0,81.47,0a72.06,72.06,0,0,0-3.36,6.83A97.68,97.68,0,0,0,49,6.83,72.37,72.37,0,0,0,45.64,0,105.89,105.89,0,0,0,19.39,8.09C2.79,32.65-1.71,56.6.54,80.21h0A105.73,105.73,0,0,0,32.71,96.36,77.7,77.7,0,0,0,39.6,85.25a68.42,68.42,0,0,1-10.85-5.18c.91-.66,1.8-1.34,2.66-2a75.57,75.57,0,0,0,64.32,0c.87.71,1.76,1.39,2.66,2a68.68,68.68,0,0,1-10.87,5.19,77,77,0,0,0,6.89,11.1A105.25,105.25,0,0,0,126.6,80.22h0C129.24,52.84,122.09,29.11,107.7,8.07ZM42.45,65.69C36.18,65.69,31,60,31,53s5-12.74,11.43-12.74S54,46,53.89,53,48.84,65.69,42.45,65.69Zm42.24,0C78.41,65.69,73.25,60,73.25,53s5-12.74,11.44-12.74S96.23,46,96.12,53,91.08,65.69,84.69,65.69Z"
                />
              </g>
            </g>
          </g>
        </svg>
        </div>
        )
      }
    else if(miscType === SOCIAL_CARD_TYPE.YOUTUBE){
      return(
        <div style={{ minWidth: "35px" }}>
            <a
            className="cursor-pointer"
            href={messageLink || void 0}
            target={messageLink ? "_blank" : "_self"}
            rel="noreferrer noopener"
          >
        <svg
        className='flex-shrink-0'
        
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="27"
        viewBox="-35.2 -41.333 305.067 248"
      >
        <path
          fill="red"
          d="M229.763 25.817c-2.699-10.162-10.65-18.165-20.748-20.881C190.716 0 117.333 0 117.333 0S43.951 0 25.651 4.936C15.553 7.652 7.6 15.655 4.903 25.817 0 44.236 0 82.667 0 82.667s0 38.429 4.903 56.85C7.6 149.68 15.553 157.681 25.65 160.4c18.3 4.934 91.682 4.934 91.682 4.934s73.383 0 91.682-4.934c10.098-2.718 18.049-10.72 20.748-20.882 4.904-18.421 4.904-56.85 4.904-56.85s0-38.431-4.904-56.85"
        ></path>
        <path fill="#fff" d="M93.333 117.559l61.333-34.89-61.333-34.894z"></path>
      </svg>
      </a>
      </div>
      )
    }
    else if(miscType === SOCIAL_CARD_TYPE.TIKTOK){
      return(
        <div style={{ minWidth: "28px" }}>
          <a
            className="cursor-pointer"
            href={messageLink || void 0}
            target={messageLink ? "_blank" : "_self"}
            rel="noreferrer noopener"
          >
            <TiktokIcon size={28} />
          </a>
        </div>
      )
    }
    else if(miscType === SOCIAL_CARD_TYPE.SKOOL){
      return(
        <div style={{ minWidth: "28px" }}>
          <a
            className="cursor-pointer"
            href={messageLink || void 0}
            target={messageLink ? "_blank" : "_self"}
            rel="noreferrer noopener"
          >
            <SkoolIcon size={28} />
          </a>
        </div>
      )
    }
    else if(miscType === SOCIAL_CARD_TYPE.INSTAGRAM){
      return (
        <div  className='mt-2' style={{ minWidth: "23px" }}>
          <a
            className="cursor-pointer"
            href={messageLink || void 0}
            target={messageLink ? "_blank" : "_self"}
            rel="noreferrer noopener"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className='flex-shrink-0' width="23" height="23" viewBox="0 0 102 102"><defs><radialGradient id="a" cx="6.601" cy="99.766" r="129.502" gradientUnits="userSpaceOnUse"><stop offset=".09" stop-color="#fa8f21"/><stop offset=".78" stop-color="#d82d7e"/></radialGradient><radialGradient id="b" cx="70.652" cy="96.49" r="113.963" gradientUnits="userSpaceOnUse"><stop offset=".64" stop-color="#8c3aaa" stop-opacity="0"/><stop offset="1" stop-color="#8c3aaa"/></radialGradient></defs><path fill="url(#a)" d="M25.865,101.639A34.341,34.341,0,0,1,14.312,99.5a19.329,19.329,0,0,1-7.154-4.653A19.181,19.181,0,0,1,2.5,87.694,34.341,34.341,0,0,1,.364,76.142C.061,69.584,0,67.617,0,51s.067-18.577.361-25.14A34.534,34.534,0,0,1,2.5,14.312,19.4,19.4,0,0,1,7.154,7.154,19.206,19.206,0,0,1,14.309,2.5,34.341,34.341,0,0,1,25.862.361C32.422.061,34.392,0,51,0s18.577.067,25.14.361A34.534,34.534,0,0,1,87.691,2.5a19.254,19.254,0,0,1,7.154,4.653A19.267,19.267,0,0,1,99.5,14.309a34.341,34.341,0,0,1,2.14,11.553c.3,6.563.361,8.528.361,25.14s-.061,18.577-.361,25.14A34.5,34.5,0,0,1,99.5,87.694,20.6,20.6,0,0,1,87.691,99.5a34.342,34.342,0,0,1-11.553,2.14c-6.557.3-8.528.361-25.14.361s-18.577-.058-25.134-.361" data-name="Path 16"/><path fill="url(#b)" d="M25.865,101.639A34.341,34.341,0,0,1,14.312,99.5a19.329,19.329,0,0,1-7.154-4.653A19.181,19.181,0,0,1,2.5,87.694,34.341,34.341,0,0,1,.364,76.142C.061,69.584,0,67.617,0,51s.067-18.577.361-25.14A34.534,34.534,0,0,1,2.5,14.312,19.4,19.4,0,0,1,7.154,7.154,19.206,19.206,0,0,1,14.309,2.5,34.341,34.341,0,0,1,25.862.361C32.422.061,34.392,0,51,0s18.577.067,25.14.361A34.534,34.534,0,0,1,87.691,2.5a19.254,19.254,0,0,1,7.154,4.653A19.267,19.267,0,0,1,99.5,14.309a34.341,34.341,0,0,1,2.14,11.553c.3,6.563.361,8.528.361,25.14s-.061,18.577-.361,25.14A34.5,34.5,0,0,1,99.5,87.694,20.6,20.6,0,0,1,87.691,99.5a34.342,34.342,0,0,1-11.553,2.14c-6.557.3-8.528.361-25.14.361s-18.577-.058-25.134-.361" data-name="Path 17"/><path fill="#fff" d="M461.114,477.413a12.631,12.631,0,1,1,12.629,12.632,12.631,12.631,0,0,1-12.629-12.632m-6.829,0a19.458,19.458,0,1,0,19.458-19.458,19.457,19.457,0,0,0-19.458,19.458m35.139-20.229a4.547,4.547,0,1,0,4.549-4.545h0a4.549,4.549,0,0,0-4.547,4.545m-30.99,51.074a20.943,20.943,0,0,1-7.037-1.3,12.547,12.547,0,0,1-7.193-7.19,20.923,20.923,0,0,1-1.3-7.037c-.184-3.994-.22-5.194-.22-15.313s.04-11.316.22-15.314a21.082,21.082,0,0,1,1.3-7.037,12.54,12.54,0,0,1,7.193-7.193,20.924,20.924,0,0,1,7.037-1.3c3.994-.184,5.194-.22,15.309-.22s11.316.039,15.314.221a21.082,21.082,0,0,1,7.037,1.3,12.541,12.541,0,0,1,7.193,7.193,20.926,20.926,0,0,1,1.3,7.037c.184,4,.22,5.194.22,15.314s-.037,11.316-.22,15.314a21.023,21.023,0,0,1-1.3,7.037,12.547,12.547,0,0,1-7.193,7.19,20.925,20.925,0,0,1-7.037,1.3c-3.994.184-5.194.22-15.314.22s-11.316-.037-15.309-.22m-.314-68.509a27.786,27.786,0,0,0-9.2,1.76,19.373,19.373,0,0,0-11.083,11.083,27.794,27.794,0,0,0-1.76,9.2c-.187,4.04-.229,5.332-.229,15.623s.043,11.582.229,15.623a27.793,27.793,0,0,0,1.76,9.2,19.374,19.374,0,0,0,11.083,11.083,27.813,27.813,0,0,0,9.2,1.76c4.042.184,5.332.229,15.623.229s11.582-.043,15.623-.229a27.8,27.8,0,0,0,9.2-1.76,19.374,19.374,0,0,0,11.083-11.083,27.716,27.716,0,0,0,1.76-9.2c.184-4.043.226-5.332.226-15.623s-.043-11.582-.226-15.623a27.786,27.786,0,0,0-1.76-9.2,19.379,19.379,0,0,0-11.08-11.083,27.748,27.748,0,0,0-9.2-1.76c-4.041-.185-5.332-.229-15.621-.229s-11.583.043-15.626.229" data-name="Path 18" transform="translate(-422.637 -426.196)"/></svg>
          </a>
        </div>
      );
    }
    else if(miscType===SOCIAL_CARD_TYPE.TELEGRAM){
      return (
        <div className='' style={{ minWidth: "30px" }}>
          <a
            className="cursor-pointer"
            href={messageLink || void 0}
            target={messageLink ? "_blank" : "_self"}
            rel="noreferrer noopener"
          >
<svg
     className="flex-shrink-0 -mt-1" 
  xmlns="http://www.w3.org/2000/svg"
  width="30px"
  height="30px"
  viewBox="0 0 48 48"
>
  <linearGradient
    id="BiF7D16UlC0RZ_VqXJHnXa"
    x1="9.858"
    x2="38.142"
    y1="9.858"
    y2="38.142"
    gradientUnits="userSpaceOnUse"
  >
    <stop offset="0" stopColor="#33bef0"></stop>
    <stop offset="1" stopColor="#0a85d9"></stop>
  </linearGradient>
  <path
    fill="url(#BiF7D16UlC0RZ_VqXJHnXa)"
    d="M44 24c0 11.045-8.955 20-20 20S4 35.045 4 24 12.955 4 24 4s20 8.955 20 20z"
  ></path>
  <path
    d="M10.119 23.466c8.155-3.695 17.733-7.704 19.208-8.284 3.252-1.279 4.67.028 4.448 2.113-.273 2.555-1.567 9.99-2.363 15.317-.466 3.117-2.154 4.072-4.059 2.863-1.445-.917-6.413-4.17-7.72-5.282-.891-.758-1.512-1.608-.88-2.474.185-.253.658-.763.921-1.017 1.319-1.278 1.141-1.553-.454-.412-.19.136-1.292.935-1.745 1.237-1.11.74-2.131.78-3.862.192-1.416-.481-2.776-.852-3.634-1.223-1.185-.513-1.639-2.224.14-3.03z"
    opacity="0.05"
  ></path>
  <path
    d="M10.836 23.591c7.572-3.385 16.884-7.264 18.246-7.813 3.264-1.318 4.465-.536 4.114 2.011-.326 2.358-1.483 9.654-2.294 14.545-.478 2.879-1.874 3.513-3.692 2.337-1.139-.734-5.723-3.754-6.835-4.633-.86-.679-1.751-1.463-.71-2.598.348-.379 2.27-2.234 3.707-3.614.833-.801.536-1.196-.469-.508-1.843 1.263-4.858 3.262-5.396 3.625-1.025.69-1.988.856-3.664.329-1.321-.416-2.597-.819-3.262-1.078-1.486-.576-1.506-1.816.255-2.603z"
    opacity="0.07"
  ></path>
  <path
    fill="#fff"
    d="M11.553 23.717c6.99-3.075 16.035-6.824 17.284-7.343 3.275-1.358 4.28-1.098 3.779 1.91-.36 2.162-1.398 9.319-2.226 13.774-.491 2.642-1.593 2.955-3.325 1.812-.833-.55-5.038-3.331-5.951-3.984-.833-.595-1.982-1.311-.541-2.721.513-.502 3.874-3.712 6.493-6.21.343-.328-.088-.867-.484-.604a3153.97 3153.97 0 00-9.047 6.013c-.941.639-1.845.932-3.467.466-1.226-.352-2.423-.772-2.889-.932-1.795-.616-1.369-1.414.374-2.181z"
  ></path>
</svg>
          </a>
        </div>
      );
    }
    else if(miscType===SOCIAL_CARD_TYPE.WHATSAPP){
      return (
        <div className='' style={{ minWidth: "35px" }}>
          <a
            className="cursor-pointer"
            href={messageLink || void 0}
            target={messageLink ? "_blank" : "_self"}
            rel="noreferrer noopener"
          >
<svg
className=" flex-shrink-0  -mt-1"
xmlns="http://www.w3.org/2000/svg"
width="35px"
height="35px"
fillRule="evenodd"
clipRule="evenodd"
viewBox="0 0 48 48"
>
<path
  fill="#fff"
  d="M4.9 43.3l2.7-9.8C5.9 30.6 5 27.3 5 24 5 13.5 13.5 5 24 5c5.1 0 9.8 2 13.4 5.6C41 14.2 43 18.9 43 24c0 10.5-8.5 19-19 19-3.2 0-6.3-.8-9.1-2.3l-10 2.6z"
></path>
<path
  fill="#fff"
  d="M4.9 43.8c-.1 0-.3-.1-.4-.1-.1-.1-.2-.3-.1-.5L7 33.5c-1.6-2.9-2.5-6.2-2.5-9.6C4.5 13.2 13.3 4.5 24 4.5c5.2 0 10.1 2 13.8 5.7 3.7 3.7 5.7 8.6 5.7 13.8 0 10.7-8.7 19.5-19.5 19.5-3.2 0-6.3-.8-9.1-2.3L5 43.8h-.1z"
></path>
<path
  fill="#cfd8dc"
  d="M24 5c5.1 0 9.8 2 13.4 5.6C41 14.2 43 18.9 43 24c0 10.5-8.5 19-19 19-3.2 0-6.3-.8-9.1-2.3l-10 2.6 2.7-9.8C5.9 30.6 5 27.3 5 24 5 13.5 13.5 5 24 5m0-1C13 4 4 13 4 24c0 3.4.8 6.7 2.5 9.6L3.9 43c-.1.3 0 .7.3 1 .2.2.4.3.7.3h.3l9.7-2.5c2.8 1.5 6 2.2 9.2 2.2 11 0 20-9 20-20 0-5.3-2.1-10.4-5.8-14.1C34.4 6.1 29.4 4 24 4z"
></path>
<path
  fill="#40c351"
  d="M35.2 12.8c-3-3-6.9-4.6-11.2-4.6-8.7 0-15.8 7.1-15.8 15.8 0 3 .8 5.9 2.4 8.4l.4.6-1.6 5.8 6-1.6.6.3c2.4 1.4 5.2 2.2 8 2.2 8.7 0 15.8-7.1 15.8-15.8 0-4.1-1.6-8.1-4.6-11.1z"
></path>
<path
  fill="#fff"
  d="M19.3 16c-.4-.8-.7-.8-1.1-.8h-.9c-.3 0-.8.1-1.3.6-.4.5-1.7 1.6-1.7 4s1.7 4.6 1.9 4.9 3.3 5.3 8.1 7.2c4 1.6 4.8 1.3 5.7 1.2.9-.1 2.8-1.1 3.2-2.3.4-1.1.4-2.1.3-2.3-.1-.2-.4-.3-.9-.6s-2.8-1.4-3.2-1.5c-.4-.2-.8-.2-1.1.2-.3.5-1.2 1.5-1.5 1.9-.3.3-.6.4-1 .1-.5-.2-2-.7-3.8-2.4-1.4-1.3-2.4-2.8-2.6-3.3-.3-.5 0-.7.2-1 .2-.2.5-.6.7-.8.2-.3.3-.5.5-.8.2-.3.1-.6 0-.8-.2-.2-1.1-2.5-1.5-3.5z"
></path>
</svg>
          </a>
        </div>
      );
    }
    else if(miscType===SOCIAL_CARD_TYPE.GOODFIRMS){
      return (
        <div className='' style={{ minWidth: "25px" }}>
          <a
            className="cursor-pointer"
            href={messageLink || void 0}
            target={messageLink ? "_blank" : "_self"}
            rel="noreferrer noopener"
          >
              <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25px"
    height="25px"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="-0.5 -0.5 272 261"
  >
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#fbfdfd"
        d="M -0.5,-0.5 C 84.8333,-0.5 170.167,-0.5 255.5,-0.5C 194.326,-0.16566 133.326,0.83434 72.5,2.5C 69.2154,2.92809 66.2154,3.92809 63.5,5.5C 35.3645,15.3008 17.6978,34.6341 10.5,63.5C 9.83333,63.5 9.16667,63.5 8.5,63.5C 7.67331,68.6509 7.17331,73.9842 7,79.5C 6.83333,106.167 6.66667,132.833 6.5,159.5C 6.84924,187.439 6.84924,215.272 6.5,243C 6.63874,244.301 7.30541,245.134 8.5,245.5C 8.1936,248.385 8.52693,251.052 9.5,253.5C 32.6607,254.498 55.994,254.831 79.5,254.5C 79.5,198.167 79.5,141.833 79.5,85.5C 79.6355,81.5617 81.1355,78.2283 84,75.5C 86.4795,73.6859 88.9795,72.0192 91.5,70.5C 146.167,70.5 200.833,70.5 255.5,70.5C 255.833,70.5 256.167,70.5 256.5,70.5C 257.498,47.0059 257.831,23.3392 257.5,-0.5C 262.167,-0.5 266.833,-0.5 271.5,-0.5C 271.5,86.5 271.5,173.5 271.5,260.5C 180.833,260.5 90.1667,260.5 -0.5,260.5C -0.5,173.5 -0.5,86.5 -0.5,-0.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#defeff"
        d="M 255.5,-0.5 C 256.167,-0.5 256.833,-0.5 257.5,-0.5C 257.831,23.3392 257.498,47.0059 256.5,70.5C 256.5,47.5 256.5,24.5 256.5,1.5C 195.095,1.1707 133.762,1.50403 72.5,2.5C 133.326,0.83434 194.326,-0.16566 255.5,-0.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#1a79d3"
        d="M 256.5,70.5 C 256.167,70.5 255.833,70.5 255.5,70.5C 255.5,70.1667 255.5,69.8333 255.5,69.5C 255.5,47.8333 255.5,26.1667 255.5,4.5C 196.176,2.50382 136.509,1.83715 76.5,2.5C 72.4958,4.3879 68.1624,5.3879 63.5,5.5C 66.2154,3.92809 69.2154,2.92809 72.5,2.5C 133.762,1.50403 195.095,1.1707 256.5,1.5C 256.5,24.5 256.5,47.5 256.5,70.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#0087fe"
        d="M 76.5,2.5 C 136.509,1.83715 196.176,2.50382 255.5,4.5C 195.491,5.16285 135.824,4.49618 76.5,2.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#0185f8"
        d="M 76.5,2.5 C 135.824,4.49618 195.491,5.16285 255.5,4.5C 255.5,26.1667 255.5,47.8333 255.5,69.5C 201.499,69.6667 147.499,69.5 93.5,69C 90.6735,66.909 90.0068,67.409 91.5,70.5C 88.9795,72.0192 86.4795,73.6859 84,75.5C 81.1355,78.2283 79.6355,81.5617 79.5,85.5C 79.1667,85.5 78.8333,85.5 78.5,85.5C 77.5004,138.762 77.167,192.762 77.5,247.5C 76.8333,196.998 76.1667,146.332 75.5,95.5C 74.03,90.27 73.3633,84.9367 73.5,79.5C 71.1667,79.5 68.8333,79.5 66.5,79.5C 65.2788,82.679 64.2788,86.0123 63.5,89.5C 63.6667,91.1667 63.8333,92.8333 64,94.5C 64.5736,91.6808 65.9069,89.3475 68,87.5C 68.772,87.6448 69.4387,87.9781 70,88.5C 70.4966,90.8098 70.6633,93.1432 70.5,95.5C 69.5,95.5 68.5,95.5 67.5,95.5C 67.1716,143.876 67.5049,192.209 68.5,240.5C 68.1131,241.72 67.2798,242.387 66,242.5C 47.8407,241.799 29.674,241.133 11.5,240.5C 11.5,241.5 11.5,242.5 11.5,243.5C 32.4778,244.133 53.4778,244.8 74.5,245.5C 73.2532,247.042 73.2532,248.542 74.5,250C 73.5,250.5 72.5,251 71.5,251.5C 69.2241,250.787 66.8907,250.287 64.5,250C 67.2889,249.759 69.9556,249.092 72.5,248C 72.1667,247.667 71.8333,247.333 71.5,247C 50.9074,246.771 30.5741,246.271 10.5,245.5C 10.5,185.833 10.5,126.167 10.5,66.5C 10.5,65.5 10.5,64.5 10.5,63.5C 17.6978,34.6341 35.3645,15.3008 63.5,5.5C 68.1624,5.3879 72.4958,4.3879 76.5,2.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#1579de"
        d="M 255.5,69.5 C 255.5,69.8333 255.5,70.1667 255.5,70.5C 200.833,70.5 146.167,70.5 91.5,70.5C 90.0068,67.409 90.6735,66.909 93.5,69C 147.499,69.5 201.499,69.6667 255.5,69.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#eafefe"
        d="M 8.5,63.5 C 9.16667,63.5 9.83333,63.5 10.5,63.5C 10.5,64.5 10.5,65.5 10.5,66.5C 9.5009,128.664 9.16757,190.998 9.5,253.5C 8.52693,251.052 8.1936,248.385 8.5,245.5C 8.5,184.833 8.5,124.167 8.5,63.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#fefdf3"
        d="M 8.5,63.5 C 8.5,124.167 8.5,184.833 8.5,245.5C 7.30541,245.134 6.63874,244.301 6.5,243C 6.84924,215.272 6.84924,187.439 6.5,159.5C 6.66667,132.833 6.83333,106.167 7,79.5C 7.17331,73.9842 7.67331,68.6509 8.5,63.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#0185fb"
        d="M 77.5,247.5 C 76.2721,249.01 76.2721,250.51 77.5,252C 55.1692,252.5 32.8358,252.667 10.5,252.5C 10.5,250.167 10.5,247.833 10.5,245.5C 30.5741,246.271 50.9074,246.771 71.5,247C 71.8333,247.333 72.1667,247.667 72.5,248C 69.9556,249.092 67.2889,249.759 64.5,250C 66.8907,250.287 69.2241,250.787 71.5,251.5C 72.5,251 73.5,250.5 74.5,250C 73.2532,248.542 73.2532,247.042 74.5,245.5C 53.4778,244.8 32.4778,244.133 11.5,243.5C 11.5,242.5 11.5,241.5 11.5,240.5C 29.674,241.133 47.8407,241.799 66,242.5C 67.2798,242.387 68.1131,241.72 68.5,240.5C 67.5049,192.209 67.1716,143.876 67.5,95.5C 68.5,95.5 69.5,95.5 70.5,95.5C 70.6633,93.1432 70.4966,90.8098 70,88.5C 69.4387,87.9781 68.772,87.6448 68,87.5C 65.9069,89.3475 64.5736,91.6808 64,94.5C 63.8333,92.8333 63.6667,91.1667 63.5,89.5C 64.2788,86.0123 65.2788,82.679 66.5,79.5C 68.8333,79.5 71.1667,79.5 73.5,79.5C 73.3633,84.9367 74.03,90.27 75.5,95.5C 76.1667,146.332 76.8333,196.998 77.5,247.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#2b87e4"
        d="M 10.5,66.5 C 10.5,126.167 10.5,185.833 10.5,245.5C 10.5,247.833 10.5,250.167 10.5,252.5C 32.8358,252.667 55.1692,252.5 77.5,252C 76.2721,250.51 76.2721,249.01 77.5,247.5C 77.167,192.762 77.5004,138.762 78.5,85.5C 78.5,141.5 78.5,197.5 78.5,253.5C 55.5,253.5 32.5,253.5 9.5,253.5C 9.16757,190.998 9.5009,128.664 10.5,66.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#0086f4"
        d="M 70.5,95.5 C 71.5,95.5 72.5,95.5 73.5,95.5C 73.6667,144.501 73.5,193.501 73,242.5C 72.586,242.043 72.086,241.709 71.5,241.5C 70.5001,192.838 70.1667,144.171 70.5,95.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#0184fd"
        d="M 127.5,98.5 C 172.167,98.5 216.833,98.5 261.5,98.5C 261.5,99.5 261.5,100.5 261.5,101.5C 217.08,100.202 172.413,100.202 127.5,101.5C 170.329,102.501 212.996,103.501 255.5,104.5C 209.458,104.447 163.458,104.447 117.5,104.5C 113.726,104.14 113.06,102.806 115.5,100.5C 119.647,99.833 123.647,99.1663 127.5,98.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#0186f4"
        d="M 261.5,101.5 C 261.831,131.671 261.498,161.671 260.5,191.5C 260.5,164.833 260.5,138.167 260.5,111.5C 253.833,111.167 253.833,110.833 260.5,110.5C 259.893,107.924 258.726,105.591 257,103.5C 256.617,104.056 256.117,104.389 255.5,104.5C 212.996,103.501 170.329,102.501 127.5,101.5C 172.413,100.202 217.08,100.202 261.5,101.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#0185f8"
        d="M 112.5,98.5 C 112.833,98.5 113.167,98.5 113.5,98.5C 118.167,98.5 122.833,98.5 127.5,98.5C 123.647,99.1663 119.647,99.833 115.5,100.5C 113.06,102.806 113.726,104.14 117.5,104.5C 163.458,104.447 209.458,104.447 255.5,104.5C 256.117,104.389 256.617,104.056 257,103.5C 258.726,105.591 259.893,107.924 260.5,110.5C 253.833,110.833 253.833,111.167 260.5,111.5C 260.5,138.167 260.5,164.833 260.5,191.5C 260.5,194.833 260.5,198.167 260.5,201.5C 252.906,229.425 234.906,246.425 206.5,252.5C 173.5,252.5 140.5,252.5 107.5,252.5C 107.5,230.5 107.5,208.5 107.5,186.5C 135.672,186.831 163.672,186.498 191.5,185.5C 192.957,183.372 193.957,181.038 194.5,178.5C 195.49,172.69 195.823,166.69 195.5,160.5C 166.5,160.5 137.5,160.5 108.5,160.5C 107.347,141.573 107.18,122.573 108,103.5C 109.707,101.963 111.207,100.296 112.5,98.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#2d89e6"
        d="M 112.5,98.5 C 111.207,100.296 109.707,101.963 108,103.5C 107.18,122.573 107.347,141.573 108.5,160.5C 106.513,142.53 105.846,124.197 106.5,105.5C 107.054,101.945 109.054,99.6118 112.5,98.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#2882da"
        d="M 113.5,98.5 C 162.997,97.5011 212.664,97.1678 262.5,97.5C 262.667,130.502 262.5,163.502 262,196.5C 261.802,198.382 261.302,200.048 260.5,201.5C 260.5,198.167 260.5,194.833 260.5,191.5C 261.498,161.671 261.831,131.671 261.5,101.5C 261.5,100.5 261.5,99.5 261.5,98.5C 216.833,98.5 172.167,98.5 127.5,98.5C 122.833,98.5 118.167,98.5 113.5,98.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#7ebbfc"
        d="M 106.5,105.5 C 105.846,124.197 106.513,142.53 108.5,160.5C 137.5,160.5 166.5,160.5 195.5,160.5C 195.823,166.69 195.49,172.69 194.5,178.5C 194.5,172.833 194.5,167.167 194.5,161.5C 164.833,161.5 135.167,161.5 105.5,161.5C 105.17,142.659 105.503,123.993 106.5,105.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#1e83e4"
        d="M 191.5,185.5 C 163.672,186.498 135.672,186.831 107.5,186.5C 107.5,208.5 107.5,230.5 107.5,252.5C 140.5,252.5 173.5,252.5 206.5,252.5C 173.338,253.498 140.004,253.832 106.5,253.5C 106.5,230.833 106.5,208.167 106.5,185.5C 134.833,185.5 163.167,185.5 191.5,185.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#85c4fe"
        d="M 78.5,85.5 C 78.8333,85.5 79.1667,85.5 79.5,85.5C 79.5,141.833 79.5,198.167 79.5,254.5C 55.994,254.831 32.6607,254.498 9.5,253.5C 32.5,253.5 55.5,253.5 78.5,253.5C 78.5,197.5 78.5,141.5 78.5,85.5 Z"
      />
    </g>
  </svg>
          </a>
        </div>
      );
    }
    else if(miscType===SOCIAL_CARD_TYPE.CLUTCH){
      return (
        <div className='' style={{ minWidth: "28px" }}>
          <a
            className="cursor-pointer"
            href={messageLink || void 0}
            target={messageLink ? "_blank" : "_self"}
            rel="noreferrer noopener"
          >
              <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28px"
    height="28px"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="-0.5 -0.5 128 152"
  >
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#fcfcfc"
        d="M -0.5,-0.5 C 42.1667,-0.5 84.8333,-0.5 127.5,-0.5C 127.5,50.1667 127.5,100.833 127.5,151.5C 84.8333,151.5 42.1667,151.5 -0.5,151.5C -0.5,100.833 -0.5,50.1667 -0.5,-0.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#18323c"
        d="M 62.5,6.5 C 86.9439,4.5908 107.944,12.0908 125.5,29C 118.357,36.0655 111.024,42.8988 103.5,49.5C 89.7683,36.2327 73.7683,32.7327 55.5,39C 36.7364,50.051 30.2364,66.2176 36,87.5C 43.8396,107.175 58.3396,115.675 79.5,113C 88.7877,110.942 96.621,106.442 103,99.5C 110.5,107 118,114.5 125.5,122C 98.4911,146.522 68.4911,150.855 35.5,135C 10.0838,117.135 -0.416196,92.6345 4,61.5C 11.7768,30.5543 31.2768,12.221 62.5,6.5 Z"
      />
    </g>
    <g>
      <path
        style={{
          opacity: 1,
        }}
        fill="#ef4536"
        d="M 63.5,53.5 C 83.7251,51.486 93.5584,60.486 93,80.5C 86.0098,97.2207 74.1765,101.721 57.5,94C 49.0051,86.5244 46.5051,77.3578 50,66.5C 53.0762,60.5887 57.5762,56.2554 63.5,53.5 Z"
      />
    </g>
  </svg>
          </a>
        </div>
      );
    }
    else if(miscType===SOCIAL_CARD_TYPE.YELP){
      return (
        <div className='' style={{ minWidth: "28px" }}>
          <a
            className="cursor-pointer"
            href={messageLink || void 0}
            target={messageLink ? "_blank" : "_self"}
            rel="noreferrer noopener"
          >
                    <svg
            xmlns="http://www.w3.org/2000/svg"
            width={28}
            height={28}
            viewBox="0.0002537965774536133 0.00032529979944229126 35.999359130859375 48.000267028808594"
            >
            <path
              fill="#D32200"
              fillRule="evenodd"
              d="M.917 23.109c-.767 1.249-1.09 5.183-.826 7.795.094.862.248 1.58.47 2.01.306.592.823.946 1.412.966.377.02.611-.045 7.703-2.363 0 0 3.152-1.02 3.165-1.027.786-.201 1.314-.936 1.367-1.875.05-.96-.44-1.81-1.244-2.117 0 0-2.22-.92-2.226-.92-7.62-3.194-7.962-3.32-8.347-3.324-.588-.023-1.113.277-1.474.855zm17.048 23.795c.124-.362.138-.612.159-8.183 0 0 .018-3.343.02-3.38.05-.817-.47-1.562-1.328-1.9-.88-.343-1.827-.13-2.359.545 0 0-1.554 1.875-1.56 1.875-5.342 6.37-5.56 6.664-5.692 7.042a1.534 1.534 0 0 0-.083.695c.032.336.18.672.43.98 1.237 1.498 7.175 3.718 9.07 3.39.66-.124 1.138-.5 1.343-1.064zm12.042-2.634c1.79-.725 5.696-5.772 5.97-7.715.095-.675-.112-1.258-.571-1.629-.3-.23-.532-.32-7.618-2.682 0 0-3.108-1.044-3.149-1.063-.75-.296-1.611-.024-2.188.703-.598.743-.692 1.72-.213 2.462l1.252 2.068c4.209 6.944 4.53 7.434 4.833 7.674.468.375 1.063.437 1.684.182zm-3.66-17.872c8.054-1.982 8.365-2.088 8.684-2.3.486-.331.731-.89.69-1.572 0-.022.003-.043 0-.069-.207-2.007-3.674-7.236-5.38-8.083-.605-.296-1.212-.275-1.71.066-.311.207-.542.517-4.854 6.508 0 0-1.95 2.699-1.972 2.724-.515.633-.52 1.545-.02 2.325.52.807 1.399 1.2 2.203.974 0 0-.033.057-.042.069.397-.155 1.109-.33 2.401-.642zm-8.088-6.757c-.138-3.242-1.097-17.684-1.21-18.354-.166-.605-.63-1.038-1.302-1.21-2.054-.52-9.911 1.72-11.369 3.247-.466.495-.641 1.107-.5 1.645.227.48 9.966 16.044 9.966 16.044 1.441 2.372 2.615 2.004 2.998 1.883.382-.122 1.55-.49 1.417-3.255z"
            />
            </svg>
          </a>
        </div>
      );
    }
    else if(miscType===SOCIAL_CARD_TYPE.DESIGNRUSH)
      return (<div className="" style={{ minWidth: "28px" }}>
    <a
      className="cursor-pointer"
      href={messageLink || void 0}
      target={messageLink ? "_blank" : "_self"}
      rel="noreferrer noopener"
    >
           <svg
  xmlns="http://www.w3.org/2000/svg"
  version="1.1"
  width="28px"
  height="28px"
  style={{
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
  }}
  xmlnsXlink="http://www.w3.org/1999/xlink"
  viewBox="-0.5 -0.5 300 300"
>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#fefefe"
      d="M -0.5,-0.5 C 99.5,-0.5 199.5,-0.5 299.5,-0.5C 299.5,99.5 299.5,199.5 299.5,299.5C 199.5,299.5 99.5,299.5 -0.5,299.5C -0.5,199.5 -0.5,99.5 -0.5,-0.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#78ccf7"
      d="M 159.5,34.5 C 157.409,34.3184 155.409,34.6518 153.5,35.5C 150.287,33.0308 146.953,32.8641 143.5,35C 143.339,39.2562 143.006,43.4229 142.5,47.5C 141.732,46.7375 141.232,45.7375 141,44.5C 140.751,39.9534 140.585,35.62 140.5,31.5C 141.877,26.0229 144.877,21.6895 149.5,18.5C 154.34,22.8378 157.674,28.1711 159.5,34.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#74bef6"
      d="M 159.5,34.5 C 162.565,40.4329 163.899,46.7663 163.5,53.5C 162.518,51.5939 161.518,49.5939 160.5,47.5C 159.571,48.6888 159.238,50.0222 159.5,51.5C 158.5,51.5 157.5,51.5 156.5,51.5C 156.5,50.1667 156.5,48.8333 156.5,47.5C 151.951,47.5559 148.117,49.2226 145,52.5C 144.617,51.944 144.117,51.6107 143.5,51.5C 143.167,50.1667 142.833,48.8333 142.5,47.5C 143.006,43.4229 143.339,39.2562 143.5,35C 146.953,32.8641 150.287,33.0308 153.5,35.5C 155.409,34.6518 157.409,34.3184 159.5,34.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#716ce9"
      d="M 140.5,31.5 C 140.585,35.62 140.751,39.9534 141,44.5C 141.232,45.7375 141.732,46.7375 142.5,47.5C 142.833,48.8333 143.167,50.1667 143.5,51.5C 143.785,53.288 143.452,54.9547 142.5,56.5C 141.5,55.1667 140.5,55.1667 139.5,56.5C 138.818,55.7573 138.151,55.0906 137.5,54.5C 134.34,46.2653 135.34,38.5986 140.5,31.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#7ed1f2"
      d="M 178.5,68.5 C 177.515,72.6344 177.182,76.9677 177.5,81.5C 176.883,81.6107 176.383,81.944 176,82.5C 175.818,76.1031 175.152,69.7697 174,63.5C 172.983,60.972 171.816,60.972 170.5,63.5C 169.453,62.0777 169.453,60.5777 170.5,59C 170.164,57.9701 169.497,57.4701 168.5,57.5C 168.201,55.396 168.534,53.396 169.5,51.5C 173.445,56.6673 176.445,62.3339 178.5,68.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#74aaf5"
      d="M 163.5,53.5 C 163.558,59.2679 162.058,64.6012 159,69.5C 155.33,74.3357 151.164,78.669 146.5,82.5C 146.373,79.7279 144.873,78.3946 142,78.5C 138.29,78.9517 134.623,79.6183 131,80.5C 129.05,80.2926 127.884,79.2926 127.5,77.5C 130.969,78.7 134.302,78.7 137.5,77.5C 141.066,77.2078 144.066,75.8744 146.5,73.5C 149.139,72.2942 149.972,70.2942 149,67.5C 146.655,65.1883 144.155,64.1883 141.5,64.5C 139.587,61.4327 138.253,58.0994 137.5,54.5C 138.151,55.0906 138.818,55.7573 139.5,56.5C 140.5,55.1667 141.5,55.1667 142.5,56.5C 143.452,54.9547 143.785,53.288 143.5,51.5C 144.117,51.6107 144.617,51.944 145,52.5C 148.117,49.2226 151.951,47.5559 156.5,47.5C 156.5,48.8333 156.5,50.1667 156.5,51.5C 157.5,51.5 158.5,51.5 159.5,51.5C 159.238,50.0222 159.571,48.6888 160.5,47.5C 161.518,49.5939 162.518,51.5939 163.5,53.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#79d1f6"
      d="M 146.5,73.5 C 146.5,72.5 146.5,71.5 146.5,70.5C 144.041,70.31 142.374,71.31 141.5,73.5C 141.5,70.5 141.5,67.5 141.5,64.5C 144.155,64.1883 146.655,65.1883 149,67.5C 149.972,70.2942 149.139,72.2942 146.5,73.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#74b3f5"
      d="M 168.5,57.5 C 169.497,57.4701 170.164,57.9701 170.5,59C 169.453,60.5777 169.453,62.0777 170.5,63.5C 171.816,60.972 172.983,60.972 174,63.5C 175.152,69.7697 175.818,76.1031 176,82.5C 176.383,81.944 176.883,81.6107 177.5,81.5C 176.66,83.8525 175.326,85.8525 173.5,87.5C 172.053,86.3778 171.053,84.8778 170.5,83C 167.167,82.3333 165.167,80.3333 164.5,77C 162.6,77.2133 160.933,78.0466 159.5,79.5C 163.605,72.6232 166.605,65.2898 168.5,57.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#7ceef7"
      d="M 146.5,73.5 C 144.066,75.8744 141.066,77.2078 137.5,77.5C 138.5,75.8333 139.833,74.5 141.5,73.5C 142.374,71.31 144.041,70.31 146.5,70.5C 146.5,71.5 146.5,72.5 146.5,73.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#74a4f6"
      d="M 173.5,87.5 C 170.688,90.4015 167.688,93.0681 164.5,95.5C 162.105,95.7716 159.771,95.7716 157.5,95.5C 154.489,93.8044 151.823,91.8044 149.5,89.5C 152.5,85.8333 155.833,82.5 159.5,79.5C 160.933,78.0466 162.6,77.2133 164.5,77C 165.167,80.3333 167.167,82.3333 170.5,83C 171.053,84.8778 172.053,86.3778 173.5,87.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#7493f2"
      d="M 127.5,77.5 C 127.884,79.2926 129.05,80.2926 131,80.5C 134.623,79.6183 138.29,78.9517 142,78.5C 144.873,78.3946 146.373,79.7279 146.5,82.5C 141.859,86.8052 137.193,91.1386 132.5,95.5C 132.179,93.9519 131.179,93.2852 129.5,93.5C 129.383,91.5165 130.05,89.8498 131.5,88.5C 130.066,87.7702 128.9,86.7702 128,85.5C 127.667,86.8333 127.333,88.1667 127,89.5C 125.041,88.2519 123.541,86.5852 122.5,84.5C 122.167,85.5 121.833,86.5 121.5,87.5C 122.175,90.1778 122.842,92.8445 123.5,95.5C 122.167,95.5 120.833,95.5 119.5,95.5C 119.117,91.0615 117.284,90.3948 114,93.5C 112.56,92.8524 111.06,92.5191 109.5,92.5C 109.5,93.5 109.5,94.5 109.5,95.5C 109.167,95.5 108.833,95.5 108.5,95.5C 111.331,84.5303 115.831,74.1969 122,64.5C 122.749,69.3271 124.582,73.6604 127.5,77.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#7398f4"
      d="M 149.5,89.5 C 151.823,91.8044 154.489,93.8044 157.5,95.5C 159.771,95.7716 162.105,95.7716 164.5,95.5C 165.605,98.9086 167.772,99.9086 171,98.5C 172.459,98.8082 173.626,99.4749 174.5,100.5C 171.209,105.127 167.542,109.46 163.5,113.5C 162.833,113.833 162.167,114.167 161.5,114.5C 160.141,113.993 159.141,112.993 158.5,111.5C 155.728,117.953 153.728,117.953 152.5,111.5C 150.5,111.5 148.5,111.5 146.5,111.5C 146.5,114.167 146.5,116.833 146.5,119.5C 145.527,117.052 145.194,114.385 145.5,111.5C 144.127,111.657 142.793,111.49 141.5,111C 144.328,107.999 143.995,106.499 140.5,106.5C 141.428,105.232 141.595,103.899 141,102.5C 138.324,106.01 135.157,109.01 131.5,111.5C 130.708,113.465 130.041,115.465 129.5,117.5C 129.043,118.298 128.376,118.631 127.5,118.5C 131.192,106.137 138.525,96.4708 149.5,89.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#7280f1"
      d="M 178.5,68.5 C 181.338,78.0979 181.005,87.5979 177.5,97C 176.629,98.3638 175.629,99.5305 174.5,100.5C 173.626,99.4749 172.459,98.8082 171,98.5C 167.772,99.9086 165.605,98.9086 164.5,95.5C 167.688,93.0681 170.688,90.4015 173.5,87.5C 175.326,85.8525 176.66,83.8525 177.5,81.5C 177.182,76.9677 177.515,72.6344 178.5,68.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#7382f1"
      d="M 132.5,95.5 C 129.064,98.2186 126.23,101.552 124,105.5C 122.853,108.618 121.52,111.618 120,114.5C 119.39,121.935 119.723,129.269 121,136.5C 118.898,134.905 117.398,132.905 116.5,130.5C 118.249,124.558 119.249,118.225 119.5,111.5C 119.333,110.833 119.167,110.167 119,109.5C 118.02,110.981 116.853,112.315 115.5,113.5C 115.04,108.663 117.373,105.829 122.5,105C 121.057,103.933 119.724,102.766 118.5,101.5C 117.092,103.507 115.592,105.507 114,107.5C 112.956,106.377 112.29,105.044 112,103.5C 111.788,106.332 111.621,108.998 111.5,111.5C 110.613,106.185 109.946,100.852 109.5,95.5C 109.5,94.5 109.5,93.5 109.5,92.5C 111.06,92.5191 112.56,92.8524 114,93.5C 117.284,90.3948 119.117,91.0615 119.5,95.5C 120.833,95.5 122.167,95.5 123.5,95.5C 122.842,92.8445 122.175,90.1778 121.5,87.5C 121.833,86.5 122.167,85.5 122.5,84.5C 123.541,86.5852 125.041,88.2519 127,89.5C 127.333,88.1667 127.667,86.8333 128,85.5C 128.9,86.7702 130.066,87.7702 131.5,88.5C 130.05,89.8498 129.383,91.5165 129.5,93.5C 131.179,93.2852 132.179,93.9519 132.5,95.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#8789e4"
      d="M 108.5,95.5 C 108.5,101.833 108.5,108.167 108.5,114.5C 107.009,111.814 106.343,108.814 106.5,105.5C 106.398,101.883 107.065,98.5499 108.5,95.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#7374f4"
      d="M 108.5,95.5 C 108.833,95.5 109.167,95.5 109.5,95.5C 109.946,100.852 110.613,106.185 111.5,111.5C 111.621,108.998 111.788,106.332 112,103.5C 112.29,105.044 112.956,106.377 114,107.5C 115.592,105.507 117.092,103.507 118.5,101.5C 119.724,102.766 121.057,103.933 122.5,105C 117.373,105.829 115.04,108.663 115.5,113.5C 116.853,112.315 118.02,110.981 119,109.5C 119.167,110.167 119.333,110.833 119.5,111.5C 119.249,118.225 118.249,124.558 116.5,130.5C 112.266,126.032 109.599,120.699 108.5,114.5C 108.5,108.167 108.5,101.833 108.5,95.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#75b1f8"
      d="M 161.5,114.5 C 160.942,116.823 160.275,119.157 159.5,121.5C 156.563,119.187 153.23,117.854 149.5,117.5C 149.343,118.873 149.51,120.207 150,121.5C 152.324,122.904 153.824,124.904 154.5,127.5C 153.833,127.5 153.167,127.5 152.5,127.5C 150.025,125.23 148.025,122.563 146.5,119.5C 146.5,116.833 146.5,114.167 146.5,111.5C 148.5,111.5 150.5,111.5 152.5,111.5C 153.728,117.953 155.728,117.953 158.5,111.5C 159.141,112.993 160.141,113.993 161.5,114.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#76bff6"
      d="M 163.5,113.5 C 162.508,116.779 162.341,120.112 163,123.5C 164.11,125.037 165.61,125.703 167.5,125.5C 167.5,125.833 167.5,126.167 167.5,126.5C 163.265,127.436 158.931,127.769 154.5,127.5C 153.824,124.904 152.324,122.904 150,121.5C 149.51,120.207 149.343,118.873 149.5,117.5C 153.23,117.854 156.563,119.187 159.5,121.5C 160.275,119.157 160.942,116.823 161.5,114.5C 162.167,114.167 162.833,113.833 163.5,113.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#717df3"
      d="M 146.5,119.5 C 148.025,122.563 150.025,125.23 152.5,127.5C 148.732,126.777 145.065,125.777 141.5,124.5C 141.657,125.873 141.49,127.207 141,128.5C 139.817,127.269 138.651,127.269 137.5,128.5C 139.524,130.69 141.357,133.023 143,135.5C 143.667,136.833 143.667,138.167 143,139.5C 141.259,135.756 138.759,132.59 135.5,130C 134.1,128.562 132.433,127.729 130.5,127.5C 130.5,129.833 130.5,132.167 130.5,134.5C 127.932,129.59 126.932,124.257 127.5,118.5C 128.376,118.631 129.043,118.298 129.5,117.5C 130.041,115.465 130.708,113.465 131.5,111.5C 135.157,109.01 138.324,106.01 141,102.5C 141.595,103.899 141.428,105.232 140.5,106.5C 143.995,106.499 144.328,107.999 141.5,111C 142.793,111.49 144.127,111.657 145.5,111.5C 145.194,114.385 145.527,117.052 146.5,119.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#757bef"
      d="M 178.5,136.5 C 178.586,135.504 178.252,134.671 177.5,134C 178.624,133.751 179.624,133.251 180.5,132.5C 179.18,130.73 177.68,130.397 176,131.5C 174.375,127.933 171.542,126.266 167.5,126.5C 167.5,126.167 167.5,125.833 167.5,125.5C 173.738,124.445 178.905,121.445 183,116.5C 185,113.167 187,109.833 189,106.5C 189.701,118.072 186.201,128.072 178.5,136.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#716cf2"
      d="M 152.5,127.5 C 153.167,127.5 153.833,127.5 154.5,127.5C 158.931,127.769 163.265,127.436 167.5,126.5C 171.542,126.266 174.375,127.933 176,131.5C 177.68,130.397 179.18,130.73 180.5,132.5C 179.624,133.251 178.624,133.751 177.5,134C 178.252,134.671 178.586,135.504 178.5,136.5C 174.603,142.066 169.27,145.066 162.5,145.5C 157.178,145.98 151.845,146.313 146.5,146.5C 139.186,145.191 133.853,141.191 130.5,134.5C 130.5,132.167 130.5,129.833 130.5,127.5C 132.433,127.729 134.1,128.562 135.5,130C 138.759,132.59 141.259,135.756 143,139.5C 143.667,138.167 143.667,136.833 143,135.5C 141.357,133.023 139.524,130.69 137.5,128.5C 138.651,127.269 139.817,127.269 141,128.5C 141.49,127.207 141.657,125.873 141.5,124.5C 145.065,125.777 148.732,126.777 152.5,127.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#978dea"
      d="M 162.5,145.5 C 159.644,147.006 156.477,147.672 153,147.5C 150.639,147.496 148.473,147.163 146.5,146.5C 151.845,146.313 157.178,145.98 162.5,145.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#7d6cc7"
      d="M 231.5,148.5 C 225.259,149.826 218.926,151.16 212.5,152.5C 208.802,152.552 205.135,152.886 201.5,153.5C 211.181,150.733 221.181,149.066 231.5,148.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#5b4abd"
      d="M 57.5,147.5 C 68.7568,148.452 79.7568,150.118 90.5,152.5C 86.8183,152.335 83.1516,152.501 79.5,153C 78.2842,154.74 76.6175,155.74 74.5,156C 78.5524,157.337 82.5524,158.671 86.5,160C 85.0186,160.98 83.6853,162.147 82.5,163.5C 85.3877,164.06 87.721,162.893 89.5,160C 90.635,159.251 91.635,159.417 92.5,160.5C 90.1575,162.179 87.8242,163.846 85.5,165.5C 85.8627,166.183 86.1961,166.85 86.5,167.5C 76.2838,161.615 66.6172,154.948 57.5,147.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#7ce0f7"
      d="M 168.5,162.5 C 166.956,162.703 165.622,163.37 164.5,164.5C 159.548,163.725 154.548,163.725 149.5,164.5C 149.5,164.167 149.5,163.833 149.5,163.5C 149.443,162.391 149.11,161.391 148.5,160.5C 155.668,158.947 162.834,157.28 170,155.5C 170.833,155.833 171.667,156.167 172.5,156.5C 171.156,158.529 169.823,160.529 168.5,162.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#7055ee"
      d="M 212.5,152.5 C 211.952,155.084 210.285,156.084 207.5,155.5C 207.66,157.199 207.494,158.866 207,160.5C 197.188,170.155 186.688,178.989 175.5,187C 173.781,188.87 172.781,191.037 172.5,193.5C 166.57,195.098 162.57,198.765 160.5,204.5C 158.821,204.715 157.821,204.048 157.5,202.5C 166.087,189.399 174.92,176.399 184,163.5C 188.531,157.785 194.364,154.451 201.5,153.5C 205.135,152.886 208.802,152.552 212.5,152.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#63b1c7"
      d="M 148.5,160.5 C 149.11,161.391 149.443,162.391 149.5,163.5C 146.926,165.077 144.593,164.743 142.5,162.5C 138.365,163.109 134.365,163.776 130.5,164.5C 128.61,162.41 126.943,160.077 125.5,157.5C 126.167,157.167 126.833,156.833 127.5,156.5C 134.428,158.255 141.428,159.588 148.5,160.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#75c0f7"
      d="M 168.5,162.5 C 165.734,167.045 162.734,171.378 159.5,175.5C 159.586,174.504 159.252,173.671 158.5,173C 155.518,172.502 152.518,172.335 149.5,172.5C 149.5,169.833 149.5,167.167 149.5,164.5C 154.548,163.725 159.548,163.725 164.5,164.5C 165.622,163.37 166.956,162.703 168.5,162.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#5d93c7"
      d="M 149.5,163.5 C 149.5,163.833 149.5,164.167 149.5,164.5C 149.5,167.167 149.5,169.833 149.5,172.5C 149.5,173.833 149.5,175.167 149.5,176.5C 148.183,176.179 146.849,175.846 145.5,175.5C 144.353,175.818 143.519,176.484 143,177.5C 142.077,176.241 141.243,174.908 140.5,173.5C 139.614,174.325 139.281,175.325 139.5,176.5C 136.025,172.896 133.025,168.896 130.5,164.5C 134.365,163.776 138.365,163.109 142.5,162.5C 144.593,164.743 146.926,165.077 149.5,163.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#5b46bf"
      d="M 90.5,152.5 C 99.6597,153.33 107.493,156.996 114,163.5C 124.746,178.732 135.246,194.065 145.5,209.5C 145.167,209.5 144.833,209.5 144.5,209.5C 124.914,195.924 105.581,181.924 86.5,167.5C 86.1961,166.85 85.8627,166.183 85.5,165.5C 87.8242,163.846 90.1575,162.179 92.5,160.5C 91.635,159.417 90.635,159.251 89.5,160C 87.721,162.893 85.3877,164.06 82.5,163.5C 83.6853,162.147 85.0186,160.98 86.5,160C 82.5524,158.671 78.5524,157.337 74.5,156C 76.6175,155.74 78.2842,154.74 79.5,153C 83.1516,152.501 86.8183,152.335 90.5,152.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#73a1f5"
      d="M 149.5,172.5 C 152.518,172.335 155.518,172.502 158.5,173C 159.252,173.671 159.586,174.504 159.5,175.5C 158.974,177.23 157.974,178.564 156.5,179.5C 156.738,175.901 155.738,175.567 153.5,178.5C 151.974,178.006 150.641,177.339 149.5,176.5C 149.5,175.167 149.5,173.833 149.5,172.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#6674d3"
      d="M 149.5,176.5 C 150.641,177.339 151.974,178.006 153.5,178.5C 155.738,175.567 156.738,175.901 156.5,179.5C 154.01,183.138 151.51,186.805 149,190.5C 145.071,186.295 141.904,181.628 139.5,176.5C 139.281,175.325 139.614,174.325 140.5,173.5C 141.243,174.908 142.077,176.241 143,177.5C 143.519,176.484 144.353,175.818 145.5,175.5C 146.849,175.846 148.183,176.179 149.5,176.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#5ec1c8"
      d="M 57.5,147.5 C 66.6172,154.948 76.2838,161.615 86.5,167.5C 105.581,181.924 124.914,195.924 144.5,209.5C 144.335,211.827 143.669,213.993 142.5,216C 130.581,216.011 118.914,215.511 107.5,214.5C 106.735,215.612 105.735,216.279 104.5,216.5C 87.8074,193.625 71.4741,170.459 55.5,147C 56.4368,146.308 57.1034,146.475 57.5,147.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#5946c1"
      d="M 239.5,149.5 C 213.38,168.067 187.047,186.4 160.5,204.5C 162.57,198.765 166.57,195.098 172.5,193.5C 172.781,191.037 173.781,188.87 175.5,187C 186.688,178.989 197.188,170.155 207,160.5C 207.494,158.866 207.66,157.199 207.5,155.5C 210.285,156.084 211.952,155.084 212.5,152.5C 218.926,151.16 225.259,149.826 231.5,148.5C 233.547,148.489 235.547,148.156 237.5,147.5C 238.713,147.747 239.38,148.414 239.5,149.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#6c67d3"
      d="M 157.5,202.5 C 157.821,204.048 158.821,204.715 160.5,204.5C 160.144,206.19 159.144,207.19 157.5,207.5C 156.395,208.6 155.062,209.267 153.5,209.5C 153.167,209.5 152.833,209.5 152.5,209.5C 153.433,206.63 155.1,204.296 157.5,202.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#75effa"
      d="M 239.5,149.5 C 239.657,150.873 239.49,152.207 239,153.5C 223.848,173.786 209.014,194.119 194.5,214.5C 193.919,211.276 191.919,209.943 188.5,210.5C 178.053,210.782 167.72,211.782 157.5,213.5C 155.613,211.867 154.113,212.2 153,214.5C 152.655,212.799 153.322,211.466 155,210.5C 156.183,211.731 157.349,211.731 158.5,210.5C 157.873,209.583 157.539,208.583 157.5,207.5C 159.144,207.19 160.144,206.19 160.5,204.5C 187.047,186.4 213.38,168.067 239.5,149.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#73e4fa"
      d="M 157.5,207.5 C 157.539,208.583 157.873,209.583 158.5,210.5C 157.349,211.731 156.183,211.731 155,210.5C 153.322,211.466 152.655,212.799 153,214.5C 154.113,212.2 155.613,211.867 157.5,213.5C 167.72,211.782 178.053,210.782 188.5,210.5C 191.919,209.943 193.919,211.276 194.5,214.5C 193.551,216.777 192.218,218.777 190.5,220.5C 190.167,220.5 189.833,220.5 189.5,220.5C 188.245,218.359 186.578,217.693 184.5,218.5C 183.5,218 182.5,217.5 181.5,217C 173.73,217.115 166.23,216.282 159,214.5C 158.405,215.899 158.572,217.232 159.5,218.5C 157.892,219.242 156.225,219.409 154.5,219C 152.452,220.226 152.119,221.726 153.5,223.5C 153.658,227.517 151.991,230.517 148.5,232.5C 147.818,231.757 147.151,231.091 146.5,230.5C 146.5,230.167 146.5,229.833 146.5,229.5C 146.508,226.455 146.841,223.455 147.5,220.5C 148.228,216.114 150.228,212.447 153.5,209.5C 155.062,209.267 156.395,208.6 157.5,207.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#60b3c9"
      d="M 144.5,209.5 C 144.833,209.5 145.167,209.5 145.5,209.5C 146.885,210.574 148.051,211.907 149,213.5C 149.66,211.676 150.827,210.343 152.5,209.5C 152.833,209.5 153.167,209.5 153.5,209.5C 150.228,212.447 148.228,216.114 147.5,220.5C 145.983,220.489 144.816,219.823 144,218.5C 132.915,219.487 121.748,219.821 110.5,219.5C 110.674,221.861 111.007,224.194 111.5,226.5C 109.179,223.204 106.846,219.871 104.5,216.5C 105.735,216.279 106.735,215.612 107.5,214.5C 118.914,215.511 130.581,216.011 142.5,216C 143.669,213.993 144.335,211.827 144.5,209.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#73d8f9"
      d="M 189.5,220.5 C 188.175,221.953 187.342,221.619 187,219.5C 186.309,221.891 185.309,221.891 184,219.5C 182.812,220.563 182.312,221.897 182.5,223.5C 174.825,224.543 167.158,224.543 159.5,223.5C 158.167,222.5 156.833,221.5 155.5,220.5C 154.494,220.938 154.494,221.604 155.5,222.5C 155.043,223.298 154.376,223.631 153.5,223.5C 152.119,221.726 152.452,220.226 154.5,219C 156.225,219.409 157.892,219.242 159.5,218.5C 158.572,217.232 158.405,215.899 159,214.5C 166.23,216.282 173.73,217.115 181.5,217C 182.5,217.5 183.5,218 184.5,218.5C 186.578,217.693 188.245,218.359 189.5,220.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#5ca8c7"
      d="M 147.5,220.5 C 146.841,223.455 146.508,226.455 146.5,229.5C 145.733,228.828 145.066,227.995 144.5,227C 133.039,227.419 122.039,227.252 111.5,226.5C 111.007,224.194 110.674,221.861 110.5,219.5C 121.748,219.821 132.915,219.487 144,218.5C 144.816,219.823 145.983,220.489 147.5,220.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#74caf8"
      d="M 189.5,220.5 C 189.833,220.5 190.167,220.5 190.5,220.5C 188.218,224.777 185.551,228.777 182.5,232.5C 182.5,231.5 182.5,230.5 182.5,229.5C 174.62,230.084 166.787,230.751 159,231.5C 157.419,229.425 155.585,229.425 153.5,231.5C 152.873,232.417 152.539,233.417 152.5,234.5C 151.962,236.117 151.629,237.784 151.5,239.5C 149.833,239.5 148.167,239.5 146.5,239.5C 146.5,237.833 146.5,236.167 146.5,234.5C 146.5,233.167 146.5,231.833 146.5,230.5C 147.151,231.091 147.818,231.757 148.5,232.5C 151.991,230.517 153.658,227.517 153.5,223.5C 154.376,223.631 155.043,223.298 155.5,222.5C 154.494,221.604 154.494,220.938 155.5,220.5C 156.833,221.5 158.167,222.5 159.5,223.5C 167.158,224.543 174.825,224.543 182.5,223.5C 182.312,221.897 182.812,220.563 184,219.5C 185.309,221.891 186.309,221.891 187,219.5C 187.342,221.619 188.175,221.953 189.5,220.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#5d9ac6"
      d="M 111.5,226.5 C 122.039,227.252 133.039,227.419 144.5,227C 145.066,227.995 145.733,228.828 146.5,229.5C 146.5,229.833 146.5,230.167 146.5,230.5C 146.5,231.833 146.5,233.167 146.5,234.5C 138.878,234.803 131.378,234.47 124,233.5C 122.331,235.169 121.498,237.169 121.5,239.5C 121.5,239.833 121.5,240.167 121.5,240.5C 117.811,236.135 114.478,231.469 111.5,226.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#72bdf9"
      d="M 182.5,232.5 C 181.066,235.047 179.4,237.381 177.5,239.5C 176.972,238.279 176.305,237.113 175.5,236C 170.167,235.333 164.833,235.333 159.5,236C 159,236.5 158.5,237 158,237.5C 157.247,234.095 155.414,233.095 152.5,234.5C 152.539,233.417 152.873,232.417 153.5,231.5C 155.585,229.425 157.419,229.425 159,231.5C 166.787,230.751 174.62,230.084 182.5,229.5C 182.5,230.5 182.5,231.5 182.5,232.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#5a8ec6"
      d="M 146.5,234.5 C 146.5,236.167 146.5,237.833 146.5,239.5C 146.5,240.5 146.5,241.5 146.5,242.5C 144.956,242.297 143.622,241.63 142.5,240.5C 139.322,243.271 136.322,243.105 133.5,240C 130.87,239.155 128.536,239.655 126.5,241.5C 125.158,239.995 123.492,239.328 121.5,239.5C 121.498,237.169 122.331,235.169 124,233.5C 131.378,234.47 138.878,234.803 146.5,234.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#73aef5"
      d="M 177.5,239.5 C 175.066,243.382 172.399,247.048 169.5,250.5C 168.586,246.35 166.92,242.683 164.5,239.5C 163.5,239.5 162.5,239.5 161.5,239.5C 161.5,240.5 161.5,241.5 161.5,242.5C 160.07,242.579 158.736,242.246 157.5,241.5C 156.719,242.737 155.719,243.737 154.5,244.5C 151.916,245.085 149.249,245.085 146.5,244.5C 146.5,243.833 146.5,243.167 146.5,242.5C 146.5,241.5 146.5,240.5 146.5,239.5C 148.167,239.5 149.833,239.5 151.5,239.5C 151.629,237.784 151.962,236.117 152.5,234.5C 155.414,233.095 157.247,234.095 158,237.5C 158.5,237 159,236.5 159.5,236C 164.833,235.333 170.167,235.333 175.5,236C 176.305,237.113 176.972,238.279 177.5,239.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#5d80c4"
      d="M 121.5,239.5 C 123.492,239.328 125.158,239.995 126.5,241.5C 128.536,239.655 130.87,239.155 133.5,240C 136.322,243.105 139.322,243.271 142.5,240.5C 143.622,241.63 144.956,242.297 146.5,242.5C 146.5,243.167 146.5,243.833 146.5,244.5C 146.5,246.5 146.5,248.5 146.5,250.5C 142.996,251.13 139.496,251.797 136,252.5C 135.804,250.714 134.971,249.381 133.5,248.5C 132.932,251.412 132.932,254.412 133.5,257.5C 129.267,252.046 125.267,246.38 121.5,240.5C 121.5,240.167 121.5,239.833 121.5,239.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#7299f5"
      d="M 169.5,250.5 C 168.189,253.135 166.522,255.469 164.5,257.5C 163.534,255.943 162.2,254.61 160.5,253.5C 159.914,253.709 159.414,254.043 159,254.5C 155.049,252.088 150.882,251.422 146.5,252.5C 146.5,251.833 146.5,251.167 146.5,250.5C 146.5,248.5 146.5,246.5 146.5,244.5C 149.249,245.085 151.916,245.085 154.5,244.5C 155.719,243.737 156.719,242.737 157.5,241.5C 158.736,242.246 160.07,242.579 161.5,242.5C 161.5,241.5 161.5,240.5 161.5,239.5C 162.5,239.5 163.5,239.5 164.5,239.5C 166.92,242.683 168.586,246.35 169.5,250.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#5c6bc3"
      d="M 146.5,250.5 C 146.5,251.167 146.5,251.833 146.5,252.5C 146.5,254.833 146.5,257.167 146.5,259.5C 146.17,262.157 145.837,264.824 145.5,267.5C 146.174,270.842 146.84,274.175 147.5,277.5C 142.477,271.133 137.81,264.466 133.5,257.5C 132.932,254.412 132.932,251.412 133.5,248.5C 134.971,249.381 135.804,250.714 136,252.5C 139.496,251.797 142.996,251.13 146.5,250.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#7582f1"
      d="M 164.5,257.5 C 161.314,261.776 158.314,266.11 155.5,270.5C 155.993,268.194 156.326,265.861 156.5,263.5C 155.167,263.5 153.833,263.5 152.5,263.5C 152.5,260.833 152.5,258.167 152.5,255.5C 151.167,255.5 149.833,255.5 148.5,255.5C 148.771,257.38 148.104,258.713 146.5,259.5C 146.5,257.167 146.5,254.833 146.5,252.5C 150.882,251.422 155.049,252.088 159,254.5C 159.414,254.043 159.914,253.709 160.5,253.5C 162.2,254.61 163.534,255.943 164.5,257.5 Z"
    />
  </g>
  <g>
    <path
      style={{ opacity: 1 }}
      fill="#6e60ed"
      d="M 155.5,270.5 C 153.343,273.471 151.176,276.471 149,279.5C 148.283,278.956 147.783,278.289 147.5,277.5C 146.84,274.175 146.174,270.842 145.5,267.5C 145.837,264.824 146.17,262.157 146.5,259.5C 148.104,258.713 148.771,257.38 148.5,255.5C 149.833,255.5 151.167,255.5 152.5,255.5C 152.5,258.167 152.5,260.833 152.5,263.5C 153.833,263.5 155.167,263.5 156.5,263.5C 156.326,265.861 155.993,268.194 155.5,270.5 Z"
    />
  </g>
</svg>

    </a>
  </div>)
  
  }
  
  return (
    <div
      className={ClassNames(
        darkModeEnabled ? "border-none" : "border border-gray-200 bg-white",
        "relative z-0 transition-all w-full card-holder"
      )}
      style={{ maxWidth: "40rem", minWidth: cardWidth }}
    >
      <div
        className="card social-card-style select-none relative transition-all"
        style={
          cardBackgroundObject ? cardBackgroundObject : { }
        }
      >
         <div className={ClassNames("w-full flex padding-bottom--lg padding-bottom--lg",(fontStyle && fontStyle!=='')?`font-${fontStyle}`:'')}>
          <div style={{ minWidth: "48px" }}>
            <a
              href={cardItem[socialCardKeys.messageLink] || void 0}
              target={cardItem[socialCardKeys.messageLink] ? "_blank" : "_self"}
              rel="noreferrer"
            >
              {
                     cardItem[socialCardKeys.authorImage]?
                  <Image priority={true}  src={cardItem[socialCardKeys.authorImage] || `https://ui-avatars.com/api/?name=${encodeURI(cardItem[socialCardKeys.authorName]?cardItem[socialCardKeys.authorName]:'')}&background=d0d0e1&color=47476b&size=48`} alt="" className="overflow-hidden rounded-full w-12 h-12 object-cover" width="48px" height="48px" style={{ minWidth: '3rem' }} />
                  :
                  <img  src={`https://ui-avatars.com/api/?name=${encodeURI(cardItem[socialCardKeys.authorName]?cardItem[socialCardKeys.authorName]:'')}&background=d0d0e1&color=47476b&size=48`} alt="" className="overflow-hidden rounded-full w-12 h-12 object-cover" width="48px" height="48px" style={{ minWidth: '3rem' }}/>
                  }
             
            </a>
          </div>
          <div className="flex-grow pl-3">
            <div className="flex justify-between">
              <div className="">
                <h6 className="font-bold text-md inline">
                  <a
                    className="cursor-pointer"
                    href={cardItem[socialCardKeys.messageLink] || void 0}
                    style={
                      !darkModeEnabled
                        ? {
                            fontWeight: 600,
                            color: (cardFontColor || textColors.black.primary),
                            lineHeight: 1.2,
                            textDecoration: "none",
                          }
                        : {
                            fontWeight: 600,
                            color: (cardFontColor || textColors.light.primary),
                            lineHeight: 1.2,
                            textDecoration: "none",
                          }
                    }
                    target={
                      cardItem[socialCardKeys.messageLink] ? "_blank" : "_self"
                    }
                    rel="noreferrer noopener"
                  >
                    {cardItem[socialCardKeys.authorName]}
                  </a>
                </h6>
              </div>
              {renderIcon(cardItem[socialCardKeys.messageLink])}
            </div>
            {cardItem[socialCardKeys.workTitle] &&
              cardItem[socialCardKeys.workTitle] !== "" && (
                <div className="text-sm">
                  <a
                    style={
                      !darkModeEnabled
                        ? {
                            color: (cardFontColor || textColors.black.primary),
                            fontSize: "13.5px",
                          }
                        : {
                            color: (cardFontColor || textColors.light.primary),
                            fontSize: "13.5px",
                          }
                    }
                    className={
                      !darkModeEnabled ? "text-gray-700" : "text-gray-300"
                    }
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    {cardItem[socialCardKeys.workTitle]}
                  </a>
                </div>
              )}
          </div>
        </div>
        <div
          className="tweet-content"
          style={{
            color: !darkModeEnabled
              ? (cardFontColor || textColors.black.primary)
              : (cardFontColor || textColors.light.primary),
            fontSize: !smallSize ? "1.15em" : "1.0em",
            lineHeight: !smallSize ? 1.5 : 1.7,
          }}
        >
               <div className={ClassNames("content",(fontStyle && fontStyle!=='')?`font-${fontStyle}`:'')} dir="auto">
          {cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!==''?
                  shortenText?
                        <ReadMoreReadLess elementId={cardItem[socialCardKeys.uuid]}  refresh={()=>refresh()} text={cardItem[socialCardKeys.messageContent]} parse={parse} options={options} length={300} readMore={"Read More"} readLess={"Read Less"}/>
                        :
                        parse(cardItem[socialCardKeys.messageContent], options)
                  :
                  null
               }
          </div>
          {
                  cardItem[socialCardKeys.messageMediaImage] ?

                  cardItem[socialCardKeys.socialCardType]===SOCIAL_CARD_TYPE.DISCORD?
                  <div className="mt-4 flex justify-center w-full" style={{width: '100%', position: 'relative'}}>

                  <img loading='lazy' className="h-auto w-auto rounded-md" onLoad={()=>refresh()} objectFit="contain" style={{ width: '100%', borderRadius: '10px', objectFit: 'contain' }} src={cardItem[socialCardKeys.messageMediaImage]} alt="Image" />

               </div>
                  :
                  <div className="mt-4 flex justify-center w-full" style={{width: '100%', position: 'relative'}}>

                     <img loading='lazy' className="h-auto w-auto rounded-md" onLoad={()=>refresh()} priority={true} layout="fill" objectFit="contain" style={{ width: '100%', borderRadius: '10px', objectFit: 'contain' }} src={cardItem[socialCardKeys.messageMediaImage]} alt="Image" />

                  </div>
                  :
                  null
          }
        </div>
        <div>
          <div>
            {cardItem[socialCardKeys.starRating] &&
            cardItem[socialCardKeys.starRating] > 0 ? (
              <div
                className="whitespace-nowrap"
                style={{ lineHeight: 1, paddingBottom: !smallSize ? '1.15em' : '1em' }}
              >
                <ReactStars
                  count={5}
                  className='flex'
                  value={cardItem[socialCardKeys.starRating]}
                  edit={false}
                  size={24}
                  color2={ratingColor?ratingColor:'#f59e0b'}

                />
              </div>
            ) : null}
              <div className={(fontStyle && fontStyle!=='')?`font-${fontStyle}`:''}
              style={!darkModeEnabled
                  ? { color: (cardFontColor || textColors.black.secondary), fontSize: 14 }
                  : { color: (cardFontColor || textColors.light.secondary), fontSize: 14 }}
            >
              <span>
                {(!isDateTimeDisabled && cardItem[socialCardKeys.messageTime])
                  ? dayjs(cardItem[socialCardKeys.messageTime])
                      .locale("en")
                      .format("DD MMM YYYY")
                  : null}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiscellaneousCard;
